import styles from "./loader.module.css";
import { Image } from "react-bootstrap";
import loaderImg from "../../../assests/images/supply_corner_data_loader.svg";
export const Loader = () => {
  return (
    <div className={styles.loaderMain}>
      <Image className={styles.loaderImg} fluid src={loaderImg} />
    </div>
  );
};
